export default __webpack_public_path__ + "static/media/logo.b0ea8b3a.png";